import 'jquery.mmenu/dist/jquery.mmenu.all'

$(document).ready(function () {
	// $('#main-menu').show()
	$('#main-menu').mmenu({
		// Options
		// extensions: ['fx-menu-zoom'],
		// clone: true,
		setSelected: {
			parent: true,
		},
		navbars: [
			{
				position: 'bottom',
				content: [
					'<div class="social"><h6>Stay Up to Date</h6> <a href="" class="icons icons--instagram"></a> <a href="" class="icons icons--facebook"></a> <a href="" class="icons icons--twitter"></a> </div>',
				],
			},
			{
				position: 'bottom',
				content: [
					"<div class='menu-controls'><h6>Contact</h6> <a href='#' class='icons icons--map'></a> <a href='#' class='icons icons--phone'></a> <a href='#' class='icons icons--email'></a> </div>",
				],
			},
			{
				position: 'bottom',
				content: [
					"<div class='menu-interior-bar'> <a href='/'><div class='icons icons--home'></div></a> <a href='#' class='search-toggle'><div class='icons icons--search-menu'></div></a> <a href='#'><div class='icons icons--close' id='close'></div></a></div>",
				],
			},
		],
	})
	$('.header__menu-container nav').mmenu({
		// Options
		// extensions: ['fx-menu-zoom'],
		// clone: true,
		setSelected: {
			parent: true,
		},
		navbars: [
			{
				position: 'bottom',
				content: [
					'<div class="social"><h6>Stay Up to Date</h6> <a href="" class="icons icons--instagram"></a> <a href="" class="icons icons--facebook"></a> <a href="" class="icons icons--twitter"></a> </div>',
				],
			},
			{
				position: 'bottom',
				content: [
					"<div class='menu-controls'><h6>Contact</h6> <a href='#' class='icons icons--map'></a> <a href='#' class='icons icons--phone'></a> <a href='#' class='icons icons--email'></a> </div>",
				],
			},
			{
				position: 'bottom',
				content: [
					"<div class='menu-interior-bar'> <a href='/'><div class='icons icons--home'></div></a> <a href='#' class='search-toggle'><div class='icons icons--search-menu'></div></a> <a href='#'><div class='icons icons--close' id='close'></div></a></div>",
				],
			},
		],
	})
	var API = $('#main-menu').data('mmenu')
	var menuAPI = $('nav.header__main-menu').data('mmenu')

	$('#mobile-main-menu-toggle').click(function (event) {
		event.preventDefault()
		API.open()
		$('.search-field-container').hide()
	})

	$('#main-menu-toggle').click(function (event) {
		event.preventDefault()
		API.open()
		$('.search-field-container').hide()
	})

	$('#header__mobile-menu-toggle').click(function (event) {
		event.preventDefault()
		menuAPI.open()
		$('.search-field-container').hide()
	})

	$('#header__menu-toggle').click(function (event) {
		event.preventDefault()
		menuAPI.open()
		$('.search-field-container').hide()
	})

	$('#close').click(function (event) {
		event.preventDefault()
		if (API) {
			API.close()
		}
		if (menuAPI) {
			menuAPI.close()
		}
	})
})
